export default function removeLocalStorage() {
  localStorage.removeItem('token');
  localStorage.removeItem('tokenExpiry');
  localStorage.removeItem('lastRefreshTime');
  localStorage.removeItem('lastRefreshAttempt');
  localStorage.removeItem('permissions');
  localStorage.removeItem('token_admin');
  removeSelectedRowsLocalStorageItems();
}

export function removeSelectedRowsLocalStorageItems() {
  localStorage.removeItem('appointments-selected-row');
  localStorage.removeItem('to-cancel-appointments-selected-row');
}
